import React from "react";
import { useNavigate , Link} from 'react-router-dom';
import Header from "../Component/Header";
import AdminHeader from "../Component/AdminHeader";
import Footer from "../Component/Footer";
import SubMenu from "../Component/SubMenu";
import { useContext } from 'react';
import { ArgContext } from '../../Context/ArgProvider';

import mainBg from "../../assets/img/bg-ai-09.jpg";
import aiImg from "../../assets/img/ai-WISocr.png";
import aiIcon01 from "../../assets/img/icon-ai22.png";
import aiIcon02 from "../../assets/img/icon-ai06.png";
import aiIcon03 from "../../assets/img/icon-ai23.png";
import aiIcon04 from "../../assets/img/icon-ai14.png";
import fwImg from "../../assets/img/fw-wisplatform.png";

function WISocr() {
    // 화면 이동을 위한 네비게이터 설정
	const navigate = useNavigate();

	// 일반 또는 관리자 header 설정
	const { argInfo } = useContext(ArgContext);
	const isAdmin = argInfo?.role === 'admin';


   //이미지 클릭
    const imgClick = () => {
    const img = new Image();
    img.src = fwImg;

    img.onload = () => {
      // 이미지 실제 원본 크기 가져오기
      const imgWidth = img.naturalWidth || img.width;
      const imgHeight = img.naturalHeight || img.height;
      
      // 창 크기를 1200px로 고정하고 반응형으로 조정, 높이는 이미지 비율에 맞춤
      const w = Math.min(1200, window.innerWidth * 0.94);
      const aspectRatio = imgHeight / imgWidth;
      const h = w * aspectRatio;

      // 창을 현재 모니터 중앙에 위치시키기 (듀얼모니터 환경 고려)
      const currentScreenLeft = window.screen.availLeft || 0;
      const currentScreenWidth = window.screen.availWidth;
      const left = currentScreenLeft + (currentScreenWidth - w) / 2;
      const top = (window.screen.height - h) / 2;

      // HTML 페이지를 만들어서 이미지와 파비콘을 함께 표시
      const htmlContent = `
        <!DOCTYPE html>
        <html lang="ko">
        <head>
          <meta charset="UTF-8">
          <meta name="viewport" content="width=device-width, initial-scale=1.0">
          <title>WISocr 프레임워크</title>
          <style>
            body {
              margin: 0;
              padding: 0;
              box-sizing: border-box;
              overflow: auto;
            }
            .image-container {
              width: 100%;
              height: 100%;
              text-align: center;
              padding: 0;
              overflow: visible;
            }
            .image-container img {
              width: 100%;
              height: 100%;
              object-fit: contain;
              cursor: pointer;
              transition: transform 0.3s ease;
              transform-origin: top left;
            }
            .image-container img.zoomed {
              cursor: zoom-out;
            }
          </style>
          <script>
            function toggleZoom(img) {
              if (img.classList.contains('zoomed')) {
                // 축소: 원본 크기로
                img.style.transform = 'scale(1.0)';
                img.classList.remove('zoomed');
              } else {
                // 확대: 1.5배 또는 이미지 원본 크기 제한
                const imgNaturalWidth = ${imgWidth};
                const containerWidth = ${w};
                const scale1_5 = 1.5;
                const scale1_5Width = containerWidth * scale1_5;
                
                // 1.5배 크기가 이미지 원본보다 크면 원본 크기로, 작으면 1.5배로
                let finalScale;
                if (scale1_5Width > imgNaturalWidth) {
                  finalScale = imgNaturalWidth / containerWidth;
                } else {
                  finalScale = scale1_5;
                }
                
                img.style.transform = 'scale(' + finalScale + ')';
                img.classList.add('zoomed');
              }
            }
          </script>
        </head>
        <body>
          <div class="image-container">
            <img src="${fwImg}" alt="WISaicc 프레임워크" onclick="toggleZoom(this)" />
          </div>
        </body>
        </html>
      `;

      // 새 창 열기 - 이미지 비율에 맞춘 높이로
      const newWindow = window.open(
        "",
        "_blank",
        `width=${w},height=${h},left=${left},top=${top},resizable=yes,scrollbars=yes,menubar=no,toolbar=no,location=no,status=no`
      );

      if (newWindow) {
        newWindow.document.write(htmlContent);
        newWindow.document.close();
      }
    };
  };
  
  //파일다운로드
    const downloadFile = async () => {
    const response = await fetch("/download/brochure");
    const blob = await response.blob();
  
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "위피아_AI솔루션.pdf";
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  };
    return (<>
	<main className="page-wrapper">
		{isAdmin ? <AdminHeader /> : <Header />}
      {/* <!-- 메인 미이지 + 슬로건 --> */}
			<section className="sub-bannerWrap comOverview-banner" style={{backgroundImage: `url(`+mainBg+`)`}} >
					<div className="textBox">
            <span className="ko">비전언어모델(VLM)기반 지능형 문자인식 솔루션</span>
						<h2>WISocr</h2>
						<p>이미지·스캔문서에서 문서의 구조와 데이터의 의미구조 인식을 통해, 단순 OCR 뿐만 아니라, 이미지 문서내의 주요 영역의 추출 등 다양한 활용성을 제공합니다.</p>
					</div>
					<SubMenu />
			</section>

			<section className="container-auto sec-my ai-business-wrap">
        <section className="aiCont">
          <h4 className="title">
            <span>연관 솔루션</span>
          </h4>

          <h5 className="title">기업·기관의 비즈니스 프로세스를 혁신하세요!</h5>
          <p className="text">조직 내 모든 유형의 <span className="blue">AI 서비스와 데이터</span>를 손쉽게 연결하고, 통합된 환경에서 안전하게 운영·확장할 수 있는 엔터프라이즈 AI 허브이자, 업무 혁신의 디지털 플랫폼입니다.<br/>
          <span className="blue">복수의 AI 엔진, 멀티모달 데이터, 외부/기존 IT 시스템 및 다양한 채널</span>과의 연계를 필요로 하는 기업·기관에 특히 적합합니다.<br/>
          플랫폼 도입 시 즉각적 디지털 전환 효과와 <span className="blue">지속적 AI 확장 기반</span>을 함께 확보할 수 있습니다.</p>
          <ul className="link-wrap">
            <li> <Link to="/WISplatform">WISplatform <i></i></Link></li>
            <li> <Link to="/WISaicc">WISaicc <i></i></Link></li>
            <li> <Link to="/WISbot">WISbot <i></i></Link></li>
            <li> <Link to="/WISserch">WISsearch <i></i></Link></li>
            <li> <Link to="/WISvec">WISvec <i></i></Link></li>
            <li> <Link to="/WISrag">WISrag <i></i></Link></li>
            <li> <Link to="/WISdoc">WISdoc <i></i></Link></li>
            <li> <Link to="/WISscrap">WISscrap <i></i></Link></li>
            <li> <Link to="/WISvoice">WISvoice <i></i></Link></li>
            <li> <Link to="/WISvision">WISvision <i></i></Link></li>
          </ul>
        </section>
        <section className="aiCont">
          <h4 className="title ">
          <span>WISocr 이란?</span>
        </h4>
        <div className="textWrap">
            <div className="ai-ci"><img src={aiImg} alt="WISocr" /></div>
            <div className="info">
              <p>WISocr은 고성능 OCR(광학 문자 인식)과 대규모 언어 모델(LLM)을 결합한 AI 문자인식 솔루션입니다. 이미지, 스캔 문서, PDF 등 다양한 비정형 데이터에서 문자 정보를 정확히 추출한 뒤, LLM이 맥락을 이해하고 구조화·요약·오류 교정 등 고차원의 AI 처리를 수행합니다. 이 솔루션은 금융, 법률, 행정, 의료, 교육, 제조 등 정형·비정형 문서가 혼재하는 다양한 산업에 적용 가능합니다.
</p>

              <ul className="list">
                <li>
                  <p className="tit">표/비정형 레이아웃 분석</p>
                  <p className="txt">테이블, 리스트, 멀티컬럼, 수기 문서의 구조와 맥락을 동시에 분석</p>
                </li>
                 <li>
                  <p className="tit">핵심 정보 추출 및 자동화</p>
                  <p className="txt">이름, 금액, 날짜, 항목 등 주요 필드 자동 추출, 데이터베이스 자동 구축 연계</p>
                </li>
                 <li>
                  <p className="tit">자동 교정·품질관리·복잡문서 인식</p>
                  <p className="txt">오타·오인식 자동 감지·수정, 의미·문맥 기반 품질고도화 복잡한 레이아웃·필기체도 정확하게 처리</p>
                </li>
                 <li>
                  <p className="tit">요약·질의응답 등 LLM 확장</p>
                  <p className="txt">문서 요약, 질의응답, 주요 Risk 문구 탐지 등 AI 활용 지원 기업 ERP, RPA 등 다양한 시스템과 연동 지원</p>
                </li>
              </ul>
            </div>
        </div>
        </section>

        <section className="aiCont">
          <h4 className="title ">
            <span>특장점</span>
          </h4>
          <ul className="textWrap feature-list">
            <li>
              <span className="icon"><img src={aiIcon01} alt="OCR+LLM 멀티모달 융합"/></span>
              <p className="tit">OCR+LLM<br/>멀티모달 융합</p>
              <p className="txt">단순 문자 인식에서 나아가, LLM을 활용해 문서의 의미·관계를 파악 복잡/비정형 고정확도 추출 지원</p>
            </li>
            <li>
              <span className="icon"><img src={aiIcon02} alt="자동화 에러 방지"/></span>
              <p className="tit">자동화<br/>에러 방지</p>
              <p className="txt">수기 교정 없이 자체적으로 품질 관리, 오류 방지·데이터 신뢰성 확보</p>
            </li>
            <li>
              <span className="icon"><img src={aiIcon03} alt="다양한 언어 확장성"/></span>
              <p className="tit">다양한 언어<br/>확장성</p>
              <p className="txt">다양한 언어에 대한 인식 지원</p>
            </li>
            <li>
              <span className="icon"><img src={aiIcon04} alt="보안 프라이버시"/></span>
              <p className="tit">보안<br/>프라이버시</p>
              <p className="txt">개인정보 보호/비식별화와 데이터 품질 관리 체계로 신뢰도 보장</p>
            </li>
          </ul>
        </section>
        <section className="aiCont">
          <h4 className="title ">
            <span>아키텍처</span>
          </h4>
          <ul className="textWrap ac-list">
              <li>
                <p className="tit">소스 이미지</p>
                <p className="txt">이미지/스캔/PDF</p>
              </li>
              <li>
                <p className="tit">VLM 기반 OCR</p>
                <p className="txt">문서 구조를 포함한 문자 인식</p>
              </li>
              <li>
                <p className="tit">후처리</p>
                <p className="txt">인식 오류 수정</p>
              </li>
              <li>
                <p className="tit">분석</p>
                <p className="txt">의미 기반 문서 분석 및 추론</p>
              </li>
              <li>
                <p className="tit">프롬프트 적용</p>
                <p className="txt">원하는 데이터만 검색하거나 추출</p>
              </li>
              <li>
                <p className="tit">서비스 연계</p>
                <p className="txt">RPA/문서처리/업무 처리</p>
              </li>
            </ul>
        </section>

        <section className="aiCont">
          <h4 className="title">
            <span>프레임워크</span>
          </h4>
          <div className="textWrap framework"  onClick={imgClick}>
              <img src={fwImg} alt="WISocr 프레임워크"/>
          </div>
          
        </section>

        <section className="aiCont">
          <h4 className="title">
            <span>활용사례</span>
          </h4>
          <ul className="textWrap case-list">
              <li>
                <p className="tit">금융·보험</p>
                <p className="txt">신분증·계약서·청구서 등 비정형 문서 자동 처리·DB화, 실시간 감사 리포팅</p>
              </li>
                <li>
                <p className="tit">병원·행정기관</p>
                <p className="txt">진료기록, 처방전, 공문서, 민원 신청서 등 대량 디지털화 및 정보 정제</p>
              </li>
                <li>
                <p className="tit">유통·물류</p>
                <p className="txt">영수증, 납품서, 인보이스 등 실시간 처리 및 통계분석</p>
              </li>
                <li>
                <p className="tit">기업 전반</p>
                <p className="txt">종이 서류, 보고서 샘플 자동화·데이터 레이크 구축, 챗봇/자동Q&A 연동</p>
              </li>
          </ul>
          
        </section>

        <section className="aiCont">
          <div className="btnWrap">
            <button type="button" className="inquiry-btn" onClick={downloadFile}>브로슈어 다운로드</button>
          </div>
        </section>
        
			</section>
		</main>
	<Footer />

        </>
    )
}

export default WISocr;